import { useState, useEffect } from "react";
import { useCookieConsent } from "context/cookieConsent";

import { CookieConsentSettings } from "./CookieConsentSettings";

export const CookieConsentBanner = () => {
  const { isConsentGiven, isHydrated, acceptAll } = useCookieConsent();
  const [showSettings, setShowSettings] = useState(false);

  // Block body scroll when modal is open
  useEffect(() => {
    if (!isHydrated || isConsentGiven) return;

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [isHydrated, isConsentGiven]);

  // Don't render until hydrated to prevent flash
  if (!isHydrated || isConsentGiven) {
    return null;
  }

  if (showSettings) {
    return <CookieConsentSettings onBack={() => setShowSettings(false)} />;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center overflow-hidden bg-black/30 p-4 sm:items-center">
      <div className="max-h-full w-full max-w-4xl overflow-y-auto overscroll-contain rounded-lg bg-white p-6 shadow-xl sm:p-8">
        <h2 className="mb-4 text-2xl font-bold text-gray-900">Cenimy Twoją prywatność</h2>

        <div className="mb-6 space-y-4 text-sm text-gray-700 sm:text-base">
          <p>
            Stosujemy niezbędne pliki cookie w&nbsp;celu zapewnienia prawidłowego funkcjonowania serwisu. My i&nbsp;nasi
            partnerzy możemy również wykorzystywać opcjonalne pliki cookie w&nbsp;innych celach, w&nbsp;tym
            analitycznych i&nbsp;marketingowych. Korzystanie z&nbsp;opcjonalnych plików cookie wymaga Twojej zgody,
            którą możesz wyrazić, klikając „Akceptuję i&nbsp;przechodzę do&nbsp;serwisu”. Jeśli chcesz otrzymać
            szczegółowe informacje na&nbsp;ten temat lub zarządzać swoimi zgodami na&nbsp;stosowanie przez nas
            poszczególnych kategorii cookies, kliknij „Ustawienia zaawansowane”. Zgodę możesz wycofać w&nbsp;każdym
            momencie, zmieniając wybrane ustawienia poprzez łącze „Ustawienia prywatności” dostępne w&nbsp;stopce naszej
            strony internetowej lub w&nbsp;menu ustawień naszej aplikacji.
          </p>
          <p>
            Korzystanie z&nbsp;plików cookie wiąże się z&nbsp;przetwarzaniem Twoich danych osobowych. Ich
            Administratorem jest Librus sp. z&nbsp;o.o. z&nbsp;siedzibą w&nbsp;Katowicach. W&nbsp;pewnych przypadkach
            administratorami Twoich danych mogą być również nasi partnerzy. Więcej informacji o&nbsp;korzystaniu przez
            nas i&nbsp;naszych partnerów z&nbsp;plików cookie oraz o&nbsp;przetwarzaniu Twoich danych osobowych,
            w&nbsp;tym o&nbsp;przysługujących Ci prawach, znajdziesz w&nbsp;naszej{" "}
            <a
              href="https://www.librus.pl/polityka-prywatnosci/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:underline"
            >
              Polityce prywatności
            </a>
            .
          </p>
        </div>

        <div className="flex flex-col gap-3 sm:flex-row sm:justify-end">
          <button
            onClick={() => setShowSettings(true)}
            className="focus:ring-primary rounded-md border border-gray-300 bg-white px-6 py-3 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 focus:ring-2 focus:ring-offset-2 focus:outline-none"
          >
            Ustawienia zaawansowane
          </button>
          <button
            onClick={acceptAll}
            className="bg-primary hover:bg-primary-dark focus:ring-primary rounded-md px-6 py-3 text-sm font-medium text-white transition-colors focus:ring-2 focus:ring-offset-2 focus:outline-none"
          >
            Akceptuję i&nbsp;przechodzę do&nbsp;serwisu
          </button>
        </div>
      </div>
    </div>
  );
};
